import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCanSeeVendor } from '../hooks/useCanSeeVendor';

const VENDOR_ONLY_PATHS = [
  '/purchase-orders',
  '/purchase-analytics',
  '/vendor-rates',
  '/purchase-budget',
  '/gstr2b',
  '/goods-receipt',
  '/supplier-credit-notes',
  '/ledgers',
  '/vendor-ledger',
  '/customer-ledger',
  '/purchase-reports',
  '/gst-purchase-summary',
];

/**
 * Wraps vendor-only pages. If the current path is vendor-only and the user does not have vendor access (retail-only), redirects to dashboard.
 */
const VendorOnlyRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const canSeeVendor = useCanSeeVendor();
  const location = useLocation();
  const pathname = location.pathname.replace(/\/$/, '') || '/';
  const isVendorPath = VENDOR_ONLY_PATHS.some((p) => pathname === p || pathname.startsWith(p + '/'));
  if (!canSeeVendor && isVendorPath) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export default VendorOnlyRoute;
